export default "__VITE_ASSET__CoM1b8gp__"